<div class="tax-container">
    <header>
        <nav-bar></nav-bar>
        <div class="header-wrapper">
            <div class="banner-wrapper">
                <div class="banner landing">
                    <div class="intro-block">
                        <p class="sub-title">Tax Certification Portal</p>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <main id="main">
        <div class="content-wrapper">
            <div class="content">
                <article class="main">
                    <h1>Error</h1>
                    <span *ngIf="Jsondata.IsDevelopment; then thenBlock else elseBlock">  </span>
                    <ng-template #thenBlock>
                        <p>{{Jsondata.ErrorMessage}}</p>
                    </ng-template>
                    <ng-template #elseBlock>
                        <p>The application has encountered an unknown error. It doesn't appear to have affected your data, but our technical staff have been automatically notified and will be looking into this with the utmost urgency. </p>
                    </ng-template>
                </article>
            </div>
        </div>
    </main>
    <footer-bar></footer-bar>
</div>
